export const CommandesAbonnement = () => {
  return (
    <div>
      <h1>CommandesAbonnement</h1>
    </div>
  );
};
